import { isFeatureEnabled } from '../features';
import { getState } from '../state';
import { addCanvasImage } from '../~core/image/addCanvasImage';
import { fetchServiceReservations } from '../~graphql/controllers';

export default async function addServiceReservationImagesToCanvas() {
  const servizio = getState('selected.servizio', {});
  const projectType = getState('selected.tipo', {});

  if (
    (await isFeatureEnabled('prenotazioni.show')) &&
    projectType?.loadReservationImages &&
    servizio?.objectId
  ) {
    const where = {
      defunto_pointer: {
        have: { objectId: { equalTo: servizio.objectId } },
      },
    };
    const serviceReservations = await fetchServiceReservations(where);
    if (serviceReservations.length > 0) {
      const serviceReservation = serviceReservations[0];
      const joinProductsReservation =
        serviceReservation.join_servizi_service_reservation?.edges;
      if (joinProductsReservation) {
        joinProductsReservation.forEach((edge) => {
          const product = edge.node.servizi_pointer;
          const imageUrl = product.img?.url;
          if (product.loadInGiotto && imageUrl) {
            addCanvasImage(imageUrl, {
              left: 0,
              top: 0,
              widthCm: product.widthCm,
              heightCm: product.heightCm,
            });
          }
        });
      }
    }
  }
}
